<template>
  <div>
    <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
    <Header :experiences="experiences"/>
    <div class="row">
      <div class="col-md-12 col-sm-12">
        <div class="row">
          <div class="col-md-6 col-sm-12">
            <div class="text_desktop_header_index_container">
              ¡
              <p>Experiencias en</p>
              <p>
                gestión del
                <span style="color: rgb(139 159 236);">cambio</span>
              </p>
              <p>
                <span style="color: rgb(139 159 236);">climático</span> del sector
              </p>
              <p>agropecuario en Colombia</p>
            </div>
          </div>
        </div>
        <div class="row container_img_header">
          <img src="header_index.png" alt="desarrollo_agroclimatico" class="img-fluid img_header" />
        </div>
        <HeaderResponsive/>
      </div>
    </div>
    <div class="container" v-if="index_ready">
      <div class="row">
        <div class="col-md-6 col-sm-12" v-for="(exp, index) in this.experiences" :key="index">
          <div class="img_body_container">
            <!-- <pre>{{exp.imagesLink}}</pre> -->
            <img v-if="exp.imagesLink[0]" style="object-fit: cover;" :src="exp.imagesLink[0]" alt="desarrollo_agroclimatico" class="img-fluid img_body" />
            <div class="row">
              <div class="col-md-9 col-sm-12">
                <p style="line-height:1">{{exp.longName}}</p>
              </div>
              <div class="col-md-3 col-sm-12">
                <p style="text-align:right">
                  <a @click="navigation(exp.id)" class="btn-vermas">Ver más</a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Mapa />
    </div>

    <div class="container" v-if="details_ready">
      <second-header />
      <div class="row">
        <div class="col-md-6 col-sm-12">
          <div class="container_items">
            <p class="title_second_experiencie">Código</p>
            <p class="result_second_experience">{{ this.code }}</p>
          </div>
          <div class="container_items">
            <p class="title_second_experiencie">Ubicación</p>
            <p class="result_second_experience">{{ this.departament }} / {{this.municipality}}</p>
          </div>
          <div class="container_items">
            <p class="title_second_experiencie">Nombre</p>
            <p class="result_second_experience">{{ this.longName }}</p>
          </div>
          <div class="container_items">
            <p class="title_second_experiencie">Gremio</p>
            <p class="result_second_experience">{{ this.guild }}</p>
          </div>
          <div class="container_items">
            <p class="title_second_experiencie">Nivel y subnivel de Adaptación</p>
            <ul>
              <li>Hola</li>
              <li>Hola</li>
            </ul>
          </div>
        </div>
        <div class="col-md-6 col-sm-12">
          <div class="container_items">
            <p class="title_second_experiencie">Medida individual o conjunto de medidas.</p>
            <p class="result_second_experience">{{this.measure}}</p>
          </div>
          <div class="container_items">
            <p class="title_second_experiencie">Datos de contacto</p>
            <p
              class="result_second_experience"
            >{{this.responsible_name}} / {{this.responsible_email}} / {{this.responsible_phone}}</p>
          </div>
          <div class="container_items">
            <p class="title_second_experiencie">Proyecto o estrategia en la que se enmarca</p>
            <div class="result_second_experience">
              <p>{{this.project}}</p>
            </div>
          </div>
          <div class="container_items">
            <p class="btn btn-info btn-aceptar" @click="navigation_back()">Volver</p>
          </div>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>


<script>
import Header from "./partials/Header";
import Footer from "./partials/Footer";
import Mapa from "./partials/Mapa";
import HeaderResponsive from "./partials/HeaderResponsive"
import axios from "axios";
import api from "../../api/index"

import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
import config from '../../helpers/config';


export default {
  components: {
    Header,
    HeaderResponsive,
    Footer,
    Mapa,
    Loading,
  },
  mounted() {
    this.getExperiences();
    this.getExperiences2();
  },
  data() {
    return {
      experiences: [],
      link_1: "",
      link_2: "",
      isLoading: false,
      fullPage: true,
      index_view: true,
      detail_view: false,
      code: null,
      departament: null,
      municipality: null,
      name: null,
      longName: null,
      guild: null,
      adaptation: null,
      sub_adaptation: null,
      measure: null,
      responsible_name: null,
      responsible_email: null,
      responsible_phone: null,
      responsible_charge: null
    };
  },
  methods: {
    getExperiences2: api.getExperiences,
    onMapClick: function(attr){
      console.log({
        group: 'map',
        title: 'State clicked',
        text: `You clicked on state with id: ${attr.mapId} and title: ${attr.title}`
      });
    },
    navigation(experience) {
      this.$router.push({ name: 'DetalleExp', query: { user_id: experience } })
    },
    navigation_back() {
      this.index_view = true;
      this.detail_view = false;
    },
    getExperiences() {
      this.isLoading = true;
      axios
        .get(
          `${config.urlApi}/experiences?filter[limit]=2&filter[include]=locationDepartments&filter[include]=locationMunicipalities&filter[where][expStatusId]=1&filter[order]=id%20DESC&filter[where][imagesLink][neq]=[]`,
          {}
        )
        .then(response => {
          this.experiences = response.data;
          this.isLoading = false;

          //PROBLEMA CON TRAERSE LOS FILES, NO SE SEPARARON LAS IMAGENES DE LOS ANEXOS
          //Y POR LO MENOS UNA IMAGEN POR EXPERIENCIA DEBE SUBIRSE
        })
        .catch(function(error) {
          ////console.log(error)
        });
    }
  },
  computed: {
    index_ready() {
      if (this.index_view == true && this.detail_view == false) {
        return true;
      }
    },
    details_ready() {
      if (this.detail_view == true && this.index_view == false) {
        return true;
      }
    }
  }
};
</script>


<style>
body {
  overflow-x: hidden;
}
.text_desktop_header_index_container {
  width: 64%;
  line-height: 0.4;
  font-size: 25px;
  font-weight: bolder;
  margin: auto !important;
  position: relative;
  top: 40px;
  color:rgba(255,255,255,0.8);
  left:120%;
}
.img_header {
  width: 100% !important;
  height: 480px !important;
}
.img_body {
  width: 100%;
  height: 250px !important;
  margin-bottom: 20px;
}
.img_body_container {
  width: 100%;
  margin: auto;
  margin-top: 20px;
}
.img_body_container > .row > .col-md-9 > p,
.img_body_container > .row > .col-md-12 > p {
  line-height: 0.4;
}
.btn-vermas {
  font-weight: bolder !important;
  color: #3366cc !important;
  text-decoration: underline !important;
  font-size: 20px;
}
.btn-vermas:hover {
  cursor: pointer;
}
.container_img_header {
  margin-top: -110px;
}
@media (max-width: 768px) {
  .img_header,
  .text_desktop_header_index_container {
    display: none;
  }
  .container_img_header {
    margin-top: 0px;
  }
}
</style>